import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { AttachmentType, CitizenReport } from '../../model/citizen-report';
import { decodeFiwareString } from '../../shared/replacer-util';

export interface CitizenReportState extends EntityState<CitizenReport> { }

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'CitizenReport' })
export class CitizenReportStore extends EntityStore<CitizenReportState> {

  constructor() {
    super();
  }

  akitaPreAddEntity(entity: CitizenReport) {
    return decodeEntity(entity);
  }

  akitaPreUpdateEntity(_: CitizenReport, newEntity: CitizenReport) {
    return decodeEntity(newEntity);
  }

}
const decodeEntity = (entity: CitizenReport) => {

  for (const attachment of entity.attachments) {
    if (attachment.attachmentType === AttachmentType.TEXT) {
      attachment.text = decodeFiwareString(attachment.text);
      return entity;
    }
  }
  return entity;
};
